import React from 'react'
import { wrapView, request } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { PROJECT_NAME } from "./constants"
import { SigurListView } from '../lib/SigurListView'
import { ModesModalSearch } from './ModesModalSearch'
import { SigurModalOrderColumn } from '../common_components/modal_order_column'
import {store} from "../index";

const STATE_FILTERS = [
  { value: 'all', label: 'Все' },
  { value: 'active', label: 'Действующие' },
  { value: 'archive', label: 'Недействующие' },
]

class ListView extends SigurListView {
  constructor(props) {
    super(props)
    this.searchModalRef = React.createRef()
    this.loadStateCounters = this.loadStateCounters.bind(this)
  }

  openSearchModal() {
    if (this.searchModalRef.current && typeof this.searchModalRef.current.show === 'function') {
      this.searchModalRef.current.show()
    }
  }

  renderModals() {
    let modals = [
      <SigurModalOrderColumn project_name={this.project_name}
      attrs={this.props.attrs}
      table_headers={this.props.table_headers}
      user_table_headers={this.props.user_table_headers} />
    ]

    if (this.props.search_form) {
      modals.push(
      <ModesModalSearch
        key="search"
        ref={this.searchModalRef}
        project_name={this.project_name}
        schema={this.props.search_form}
        data={this.props.search_data}
        onSearch={this.onSearch}
        choices={this.props.choices}
      />
      )
    }

    return [...modals, ...(super.renderModals() || [])]
  }

  componentDidMount() {
    this.loadStateCounters()
  }

  componentDidUpdate(prevProps) {
    if (!this.props.search_preset) {
      this.setStageFilter('active')
    } else if (prevProps.search_preset !== this.props.search_preset) {
      this.updateItems(1)
    }

    if (prevProps.search_data !== this.props.search_data) {
      this.loadStateCounters()
    }
  }

  setStageFilter(value) {
    store.dispatch({ type: `${this.project_name}_preset`, data: value })
    store.dispatch({ type: `${this.project_name}_list_clean` })
    this.setState({ preset_counters: {} })
  }

  loadStateCounters() {
    const current = this.props.search_data || {}
    const { state: _state, ...baseFilterData } = current

    STATE_FILTERS.forEach(({ value }) => {
      const key = value || '__all__'

      const filter_data = value ? { ...baseFilterData, state: value } : baseFilterData
      request({
        method: 'post',
        url: `/api/${this.project_name}/get_preset_counter`,
        data: {
          filter_data,
          preset: value,
        },
        success: (count) => {
          this.setState((prev) => ({
            stateCounters: { ...prev.stateCounters, [key]: count || 0 },
          }))
        },
      })
    })
  }

  renderContent() {
    const currentPreset = this.props.search_preset || 'all'
    const stateCounters = this.state.stateCounters || {}
    const chips = (
      <div className="card mb-3">
        <div className="card-body py-2">
          <span className="me-2 text-muted small">Этап:</span>
          {STATE_FILTERS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              className={`btn btn-sm me-1 ${currentPreset === value ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => this.setStageFilter(value)}
            >
              {label} ({stateCounters[value || '__all__'] ?? 0})
            </button>
          ))}
        </div>
      </div>
    )
    const content = super.renderContent()
    return [chips, ...(Array.isArray(content) ? content : [content])]
  }
}

export default wrapView(ListView, (state) => {
  return stateToProps(state, PROJECT_NAME)
})
